import React, { useState, useEffect } from "react";
import {
  Modal, Box, Button, TextField, Select, MenuItem,
  Grid, Card, CardMedia, Typography, Snackbar, Alert,
  CircularProgress, IconButton
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { db } from "../firebase";
import {
  collection, addDoc, getDocs, onSnapshot, query, where
} from "firebase/firestore";

// ==================== Modal Styling ====================
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

function Createpost() {

  // ==================== States ====================
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("image");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // ==================== Fetch Divisions ====================
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "bdivisions"), (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().division,
      }));
      setDivisions(list);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  // ==================== Fetch Posts PHP API ====================
  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://whatsapp.mmischoolkm.com/fetch_posts.php");
      const data = await res.json();
      setPosts(data);
    } catch (err) {
      showToast("Failed to load posts", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // ==================== Helper Toast Function ====================
  const showToast = (msg, severity = "success") =>
    setToast({ open: true, message: msg, severity });

  // ==================== File Change ====================
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
  };

  // ==================== Save Post ====================
  const handleSubmit = async () => {
    if (!file || !title) return showToast("Add title & select file", "warning");

    setSending(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", type);
    formData.append("file", file);

    try {
      const res = await fetch("https://whatsapp.mmischoolkm.com/save_post.php", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      if (result.status === "success") {
        showToast("Post uploaded successfully");
        resetForm();
        fetchPosts();
      } else {
        showToast(result.message, "error");
      }
    } catch {
      showToast("Upload failed", "error");
    }

    setSending(false);
  };

  const resetForm = () => {
    setOpen(false);
    setTitle("");
    setFile(null);
    setPreview("");
  };

  // ==================== Delete Post ====================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this post?")) return;

    await fetch("https://whatsapp.mmischoolkm.com/delete_post.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    fetchPosts();
  };

  // ==================== Send WhatsApp ====================
  const handleSendWhatsApp = async (post) => {
    if (!division) return showToast("Select division first!", "warning");

    const wabaid = "895670676961935";
    const accesstoken =
      "EAALntLdtw0QBPyM26necVXVlinICAL33CUN3zxsAHCmSvns6cYOD2SILLkdsMZBRDMjs6FFbybZCulrZC8bptKF6duET3yArXiW560ZCQxFTtPEIBWC7Oq4LSWMwBzHkJxjPsnUF6iNatFZCsC4J3eZCHmhIICLZB32JCN19sIcxR8hlSK7dNMwnZBAxrWTFyAZDZD";

    if (!window.confirm(`Send campaign to division contacts?`)) return;

    setSending(true);

    try {
      let snapshot;

      if (division === "all") {
        snapshot = await getDocs(collection(db, "contacts"));
      } else {
        const q = query(
          collection(db, "contacts"),
          where("divisionId", "==", division)
        );
        snapshot = await getDocs(q);
      }

      const contacts = snapshot.docs
        .map((doc) => doc.data())
        .filter((c) => c.whatsapp && /^\d{10}$/.test(c.whatsapp.trim()));

      if (!contacts.length) {
        showToast("No contacts found!", "warning");
        setSending(false);
        return;
      }

      let success = 0;

      for (let c of contacts) {
        let status = "failed"; // default

        const payload = {
          messaging_product: "whatsapp",
          to: `91${c.whatsapp}`,
          type: "template",
          template: {
            name: post.type === "image" ? "mmis_img" : "mmis_video",
            language: { code: "en" },
            components: [
              {
                type: "header",
                parameters: [
                  post.type === "image"
                    ? { type: "image", image: { link: post.image } }
                    : { type: "video", video: { link: post.image } },
                ],
              },
            ],
          },
        };

        try {
          const r = await fetch(
            `https://graph.facebook.com/v22.0/${wabaid}/messages`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
              },
              body: JSON.stringify(payload),
            }
          );

          const res = await r.json();

          if (res.messages?.[0]?.id) {
            status = "sent";
            success++;
          }
        } catch {
          status = "failed";
        }

        // Save to history with status
        await addDoc(collection(db, "whatsapphistory"), {
          mobile: c.whatsapp,
          division,
          postTitle: post.title,
          type: post.type,
          status: status,          // 🔥 ADDED
          timestamp: new Date().toISOString(),
        });

        await new Promise((res) => setTimeout(res, 300));
      }

      showToast(`Sent successfully to ${success} contacts`);
    } catch {
      showToast("Sending failed", "error");
    }

    setSending(false);
  };


  // ==================== UI ====================
  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        WhatsApp Campaign 📢
      </Typography>

      <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
        Create Campaign
      </Button>

      {/* ==================== Posts List ==================== */}
      {loading ? (
        <Box textAlign="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid className="row" spacing={2} mt={1}>
          {posts.map((post) => (
            <Grid className="col-sm-3 mb-3" key={post.id}>
              <Card>
                <CardMedia
                  component={post.type === "image" ? "img" : "video"}
                  src={post.image}
                  controls={post.type === "video"}
                  sx={{ height: 250, objectFit: "cover" }}
                />

                <Box p={2}>
                  <Typography fontWeight="bold">{post.title}</Typography>

                  {/* Working MUI Select */}
                  <Select
                    fullWidth
                    value={division}
                    onChange={(e) => setDivision(e.target.value)}
                    displayEmpty
                    sx={{ mt: 1, mb: 1 }}
                  >
                    <MenuItem value="">
                      <em>Select Division</em>
                    </MenuItem>

                    {divisions.map((d) => (
                      <MenuItem key={d.id} value={d.id}>
                        {d.name}
                      </MenuItem>
                    ))}

                    <MenuItem value="all">
                      ⭐ All Contacts
                    </MenuItem>
                  </Select>

                  <Box display="flex" justifyContent="space-between">
                    <IconButton color="success" onClick={() => handleSendWhatsApp(post)}>
                      {sending ? <CircularProgress size={22} /> : <WhatsAppIcon />}
                    </IconButton>

                    <IconButton color="error" onClick={() => handleDelete(post.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* ==================== Add Post Modal ==================== */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" mb={2}>Add Campaign</Typography>

          <Select
            fullWidth
            value={type}
            onChange={(e) => setType(e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="image">Image</MenuItem>
            <MenuItem value="video">Video</MenuItem>
          </Select>

          <TextField
            fullWidth
            label="Campaign Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />

          <input type="file" accept={`${type}/*`} onChange={handleFileChange} />

          {preview && (
            <Card sx={{ mt: 2 }}>
              <CardMedia component={type} height="200" src={preview} controls />
            </Card>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={sending}
            onClick={handleSubmit}
          >
            {sending ? <CircularProgress size={22} /> : "Save Campaign"}
          </Button>
        </Box>
      </Modal>

      {/* ==================== Toast ==================== */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
      >
        <Alert severity={toast.severity} variant="filled" sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Createpost;
